<div id="wrap">
  <div id="space"></div>
  <form #registerForm="ngForm" class="registerForm">
    <div id="tab">
      <div id="tab_3">
        <div class="tab_word fontSize12 lineHeight24" id="title_3">
          	在进入学习课程前，请先验证用户身份！
        </div>
        <div id="tab_1_tel" class="input_wrap" style="margin-top: 1.2rem;">
          <input class="input_text fontSize16" type="text" name="validateCode" [(ngModel)]="validateCode" placeholder="请输入验证码" maxlength="14" />
        </div>
        <p id="CodeValidateTxt" class="validateTxt">请输入正确验证码</p>
     
        <button class="submitBtn_3 fontSize16 lineHeight24" (click)="validate()">验证</button>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/validate-form/validate-form.component.html